import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'orgbrain-chooser',
  templateUrl: './chooser.component.html',
  styleUrls: ['./chooser.component.scss'],
  standalone: false,
})
export class ChooserComponent<T> implements OnInit {
  @Input() itemTemplate!: TemplateRef<{ $implicit: T }>;
  @Input() itemFilter: (search: string) => T[] = () => [];
  @Input() label;

  searchControl = new FormControl('');
  items: T[] = [];
  isListVisible = true;

  ngOnInit() {
    this.searchControl.valueChanges.subscribe(() => {
      this.doSearch();
    });
  }
  focus() {
    this.doSearch();
  }
  doSearch(event?: Event) {
    this.isListVisible = false;
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    this.items = this.itemFilter(this.searchControl.value);
  }

  removeSearch(event?: Event) {
    if (event) event.stopPropagation();

    this.searchControl.setValue('');
    this.hideList();
  }
  hideList() {
    this.items = [];
  }
}
